export function extractErrorMessage(err: any, fallback: string): string {
  return err?.error?.message || err?.message || fallback;
} 